module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CB7G5i/tc-custom/9781607106173.jpg?1704916904400",
      "alt": "This image is the cover for the book Uncle John's Bathroom Reader Plunges into History Again, Uncle John's Bathroom Reader"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Uncle John's Bathroom Reader Plunges into History Again, Uncle John's Bathroom Reader\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("History repeats itself as Uncle John presents another volume of funny stories and fascinating facts about the past!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" For our historical trivia collection number two, we dug ever deeper into our bottomless vaults to bring you more of history’s most colorful characters, cultural milestones, funniest mishaps, and earth-shattering events. More than 500 pages of great stories, fascinating facts, and fun quizzes await you."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Read about . . . * Philosophers who fought with fireplace pokers * “Mr. Gorbachev, tear down this Wall!” * Where are they now—the Goths * The golden age of wife-selling * History’s most horrible dentist award * The French monks who invented tennis * What William the Conqueror was called before he conquered * Where are they now—the Neanderthals * Women of the Gold Rush * and much, much more! \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bathroom Readers' Institute\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The Bathroom Readers' Institute is a tight-knit group of loyal and skilled writers, researchers, and editors who have been working as a team for years. The BRI understands the habits of a very special market—Throne Sitters—and devotes itself to providing amazing facts and conversation pieces.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Portable Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0